import React, { useState } from 'react';
import * as yup from 'yup';
import { Formik } from 'formik';
import { BTInputField } from '../globals/uicomps/BTInputField';
import { withTranslation } from 'react-i18next';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { isRecaptchaEnabled } from '../globals/constants';

const LoginForm = ({ t, cbValidateLogin, changeStepValue, hideForgotPassword }) => {
     const { executeRecaptcha } = useGoogleReCaptcha();
     const [isSubmitting, setIsSubmitting] = useState(false);

     const initialValues = { username: '', password: '' };

     const schema = yup.object().shape({
          username: yup.string().required('Username is required'),
          password: yup.string().required('Password is required')
     });

     const submitLoginDetails = async (values) => {
          // Check if reCAPTCHA is enabled for current environment
          if (!isRecaptchaEnabled()) {
               cbValidateLogin(values.username, values.password);
               return;
          }

          if (!executeRecaptcha) {
               cbValidateLogin(values.username, values.password);
               return;
          }

          setIsSubmitting(true);
          try {
               // Execute reCAPTCHA
               const token = await executeRecaptcha('login');
               
               // Call the original validation function
               cbValidateLogin(values.username, values.password);
          } catch (error) {
               // Suppress detailed logging; fail open to avoid blocking users
               // Even if reCAPTCHA fails, allow login to proceed
               cbValidateLogin(values.username, values.password);
          } finally {
               setIsSubmitting(false);
          }
     };

     return (
          <React.Fragment>
               <div className="clr20"></div>

               <Formik validationSchema={schema} onSubmit={submitLoginDetails} initialValues={initialValues}>
                    {
                         ({ handleSubmit, handleChange, handleBlur, values, touched, isValid, errors }) => (
                              <form onSubmit={handleSubmit} noValidate autoComplete="off">
                                   <BTInputField 
                                        label={t('username')} 
                                        id="username" 
                                        handleBlur={handleBlur} 
                                        required={true}
                                        handleChange={handleChange}
                                        autoComplete="off"
                                        value={values.username} 
                                   />

                                   <BTInputField 
                                        type="password" 
                                        label={t('password')} 
                                        id="password" 
                                        handleBlur={handleBlur} 
                                        required={true}
                                        handleChange={handleChange}
                                        autoComplete="off"
                                        value={values.password} 
                                   />

                                   <input 
                                        className="btn btn_primary block" 
                                        type="submit"
                                        value={isSubmitting ? "Verifying..." : "Continue"} 
                                        disabled={!(values.username && values.password) || isSubmitting}
                                   />
                                   {
                                        hideForgotPassword ? '' : 
                                        <div className="forgetlink body2 right mt10 pointer" 
                                             onClick={() => { changeStepValue("forgotPassword", values.username) }}>
                                             {t('Forgot password ?')}
                                        </div>
                                   }
                              </form>
                         )
                    }
               </Formik>
               <div className="clr20"></div>
          </React.Fragment>
     );
};

export default withTranslation('translations')(LoginForm);